module.exports = __webpack_public_path__ + "img/UGX.05cfe4fc.svg";